import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const awardDocumentsApi = createApi({
  reducerPath: "awardDocumentsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/admin/award-documents`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["AwardDocuments"],
  endpoints: (builder) => ({
    getAwardDocuments: builder.query({
      query: (args = {}) => {
        const params = new URLSearchParams();
        Object.entries(args).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            params.append(key, value);
          }
        });

        const query = params.toString();
        return query ? `?${query}` : "";
      },
      providesTags: (result) => {
        const rows = Array.isArray(result?.data) ? result.data : [];
        return [
          ...rows.map((row) => ({
            type: "AwardDocuments",
            id: row.id || row.file_store_id || row.s3_key,
          })),
          { type: "AwardDocuments", id: "LIST" },
        ];
      },
    }),
    getAwardDocumentAccessUrl: builder.query({
      query: ({ id, disposition = "inline" }) => ({
        url: `/${encodeURIComponent(id)}/access-url`,
        params: { disposition },
      }),
    }),
    resolveAwardDocumentIssue: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/${encodeURIComponent(id)}/resolve-issue`,
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "AwardDocuments", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetAwardDocumentsQuery,
  useLazyGetAwardDocumentAccessUrlQuery,
  useResolveAwardDocumentIssueMutation,
} = awardDocumentsApi;

export default awardDocumentsApi;
export { awardDocumentsApi };
